import { AxiosResponse } from 'axios'
import Request from 'redux/config/services/Request'

const getComplianceOverview = (): Promise<AxiosResponse> => {
  return Request.get('/hr/compliance/overview/')
}

export default {
  getComplianceOverview,
}
